import { Formik, FormikConfig } from 'formik';
import { Adventure } from '~/components/Adventure/Adventure.hooks';
import { AdventureForm } from '~/components/Adventure/Form/AdventureForm';
import {
  JoinAdventureValues,
  useAdventureSchema,
} from '~/components/Adventure/Form/AdventureForm.hooks';

export type AdventureFormikProps = Pick<Adventure, 'id'> &
  Pick<FormikConfig<JoinAdventureValues>, 'onSubmit'> & { className?: string };

const defaultInitialValues: JoinAdventureValues = {
  count: 1,
  balance: 0,
};

export const AdventureFormik = ({ id, className, onSubmit }: AdventureFormikProps) => {
  const validationSchema = useAdventureSchema(id);
  return (
    <Formik
      initialValues={defaultInitialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}>
      <AdventureForm id={id} className={className} />
    </Formik>
  );
};
